import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
  Checkbox,
  Box,
} from "@material-ui/core";
import { Loading } from "react-admin";
import { useField } from "react-final-form";
import useMenus from "../../../hooks/useMenus";
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 10,
    marginBottom: 15,
  },
  headCheckBox: {
    backgroundColor: theme.lightOrange,
  },
}));

//HARDCODE TO SKIP SOME AUTHORIZATION MENU
const SKIP = ["New Payment", "Enquiry", "Calendar", "Campaign", "Location"];
const AuthorizeInput = (props) => {
  return <AuthorizeContent name="authorizes" />;
};

const AuthorizeContent = ({ name }) => {
  const classes = useStyles();
  let {
    input: { onChange, value: authorizes },
    //meta: { touched, error },
  } = useField(name);

  const { menus, loading, error } = useMenus();

  const handleCheckbox = (objectCode, isChecked, action) => {
    if (!authorizes) authorizes = [];

    let existingAuth = authorizes?.find(
      (auth) => auth?.object_code === objectCode
    );

    if (existingAuth) {
      if (isChecked) {
        existingAuth.action_codes.push(action);
      } else {
        existingAuth.action_codes = existingAuth.action_codes.filter(
          (ac) => ac !== action
        );
      }

      //  alert(JSON.stringify(authorizes));
      return onChange([...authorizes]);
    }

    authorizes.push({ object_code: objectCode, action_codes: [action] });
    //alert(JSON.stringify(authorizes));
    return onChange([...authorizes]);
    // return alert(JSON.stringify(authorizes));
  };

  if (loading) return <Loading />;
  if (error) {
    return <Typography>Error</Typography>;
  }

  return (
    <Box style={{ margin:"20px 50px" }}>
      <Box display="flex">
        <Typography>Authorized</Typography>
        <Typography stlye={{ color: "orange" }}> *</Typography>
      </Box>
      <Table className={classes.container}>
        <TableHead>
          <TableCell>Authorize</TableCell>
          <TableCell>Can read</TableCell>
          <TableCell>Can write</TableCell>
        </TableHead>

        {menus.map((menu) => {
          if (SKIP.find((skip) => skip === menu.name)) return null;
          return (
            <>
              <TableRow className={classes.headCheckBox}>
                <TableCell style={{ fontWeight: "bolder" }}>
                  {menu.name}
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={
                      authorizes
                        ? authorizes
                            ?.find((a) => a.object_code === menu.code)
                            ?.action_codes?.find((act) => act === "Read")
                        : false
                    }
                    onChange={(e) =>
                      handleCheckbox(menu.code, e.target.checked, "Read")
                    }
                  />
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={
                      authorizes
                        ? authorizes
                            ?.find((a) => a.object_code === menu.code)
                            ?.action_codes?.find((act) => act === "Write")
                        : false
                    }
                    onChange={(e) =>
                      handleCheckbox(menu.code, e.target.checked, "Write")
                    }
                  />
                </TableCell>
              </TableRow>
              {menu.sub_menus.length > 0
                ? menu.sub_menus.map((submenu) => {
                    if (SKIP.find((skip) => skip === submenu.name)) return null;

                    let isRead = false,
                      isWrite = false;
                    if (authorizes) {
                      const authValue = authorizes.find(
                        (a) => a.object_code === submenu.code
                      );
                      if (authValue) {
                        if (authValue.action_codes) {
                          if (
                            authValue.action_codes.find((act) => act === "Read")
                          )
                            isRead = true;

                          if (
                            authValue.action_codes.find(
                              (act) => act === "Write"
                            )
                          )
                            isWrite = true;
                        }
                      }
                    }

                    return (
                      <TableRow>
                        <TableCell style={{ fontWeight: "lighter" }}>
                          {submenu.name}
                        </TableCell>
                        <TableCell>
                          <Checkbox
                            checked={isRead}
                            onChange={(e) =>
                              handleCheckbox(
                                submenu.code,
                                e.target.checked,
                                "Read"
                              )
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Checkbox
                            checked={isWrite}
                            onChange={(e) => {
                              handleCheckbox(
                                submenu.code,
                                e.target.checked,
                                "Write"
                              );
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </>
          );
        })}
      </Table>
    </Box>
  );
};

// const createNiceLabel = (objectCode) => {
//   return objectCode.replace("PAGE:MERCHANT:", "").replace("_", " ");
// };
export default AuthorizeInput;
